<template>
  <div class="mr-2">
    <v-btn
      icon
      color="white"
      @click="generateReport()"
    >
      <v-icon>mdi-file-pdf-box</v-icon>
    </v-btn>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Formato antecedentes"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <img
                      src="@/assets/img/logo-puebla.png"
                      width="100%"
                      alt="img"
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>
                          DEPARTAMENTO DE INVESTIGACIÓN SOCIOECONÓMICA<br>INFORME DE ANTECEDENTES
                        </th>
                      </tr>
                    </thead>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DATOS PERSONALES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="9">
                              <v-row>
                                <v-col cols="12">
                                  Folio: {{ evaluacion.Derivacion.Programacion.Expediente.folio }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="8">
                                  Nombre:
                                  {{ getFullName(
                                    evaluacion.Derivacion.Programacion.Expediente.Personal) }}
                                </v-col>
                                <v-col cols="4">
                                  RFC:
                                  {{ evaluacion.Derivacion.Programacion.Expediente.Personal.rfc }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="8">
                                  Institución:
                                  {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.unidadAnalisisTactico }}
                                </v-col>
                                <v-col cols="4">
                                  Puesto: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.unidadOperaciones }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  v-if="evaluacion.Derivacion.Programacion.CatMotivoEvaluacion"
                                  cols="8"
                                >
                                  Motivo de evaluación: {{ evaluacion.Derivacion
                                    .Programacion.CatMotivoEvaluacion.title }}
                                </v-col>
                                <v-col
                                  v-else
                                  cols="8"
                                >
                                  Motivo de evaluación: NO REGISTRADO
                                </v-col>
                                <v-col cols="4">
                                  Fecha: {{ getDate(evaluacion.Derivacion
                                    .Programacion.fechaEvaluacionPsicologica) }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <img
                                :src="evaluacion.Derivacion.Programacion .Expediente.Personal.foto"
                                crossorigin="anonymous"
                                width="100%"
                                alt="test"
                              >
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>Aplicativos para consulta</th>
                        <th>Reporte de riesgos o rasgos relevantes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Plataforma México (SUIC)</td>
                        <td />
                      </tr>
                      <tr>
                        <td>RNPSP</td>
                        <td />
                      </tr>
                      <tr>
                        <td>DIGYSCAN</td>
                        <td />
                      </tr>
                      <tr>
                        <td>TELESCAN</td>
                        <td />
                      </tr>
                      <tr>
                        <td>BASES ESTATALES</td>
                        <td>
                          <v-container>
                            <v-row>
                              <v-col cols="5">
                                CE ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                            <v-row>
                              <v-col cols="5">
                                CEDHT ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                            <v-row>
                              <v-col cols="5">
                                PGJE ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                            <v-row>
                              <v-col cols="5">
                                CERESO ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                            <v-row>
                              <v-col cols="5">
                                FGR ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                            <v-row>
                              <v-col cols="5">
                                REPUVE ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                            <v-row>
                              <v-col cols="5">
                                REG. PUB. PROP. ()
                              </v-col>
                              <v-col cols="7" />
                            </v-row>
                          </v-container>
                        </td>
                      </tr>
                      <tr>
                        <td>FUENTES ABIERTAS</td>
                        <td />
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col
                cols="12"
                class="font"
              >
                En caso de riesgos detectados, se solicitará ampliación
                de información de las instancias que así se amerite.
              </v-col>
            </v-row>
          </v-container>
        </section>

        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>Solicitud de información a:</th>
                        <th>
                          Reporte de los hallazgos que se informaron,
                          por parte de la(s) instanica(s)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>No aplica</td>
                        <td>No aplica</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>Riesgos detectados en evaluaciones anteriores:</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>Hallazgos y/o riesgos que orientarán las consultas</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          Vínculos familiares, sociales y laborales:<br>
                          -
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Datos de domicilio y cambios de residencia:
                          Ubicación geográfica, índices delictivos, regiones económicas,
                          niveles de urbanización, entre otros.<br>
                          - Domicilio:<br>
                          - Actividad económica del municipio donde vive:<br>
                          - Problemática social del municipio donde vive:<br>
                          - Índices delictivos del municipio donde vive:<br>
                          - Actividad económica del municipio donde labora:<br>
                          - Problemática social del municipio donde labora:<br>
                          - Índices delictivos del municipio donde labora:<br>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Datos educativos:<br>
                          -
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Datos económicos, financieros y patrimoniales:<br>
                          Aspectos financieros: <br>
                          -
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Aspectos laborales y administrativos:<br>
                          -
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Respuestas de dependencias institucionales en años anteriores:<br>
                          -
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Observaciones:<br>
                          - {{ evaluacion.observaciones }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>ELABORÓ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              DIS
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>REVISÓ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              Jefe de departamento DIS03
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col
                cols="12"
                class="font mt"
              >
                Toda la información contenida en el presente documento está
                catalogada como CONFIDENCIAL de conformidad con la normatividad
                aplicable en los Artículos 3 Fracción II y 18 de la Ley Federal
                de Transparencia y Acceso a la Información Pública
                Gubernamental y por el Artículo 25 de la Ley de Acceso
                a la Información Pública y Protección de Datos Personales para el
                Estado de Morelos.
              </v-col>
            </v-row>
          </v-container>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      options: {
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        margin: [8, 0, 8, 0],
      },
      contenidoEstudios: [
        { text: 'NIVEL DE ESTUDIOS' },
        { text: 'TIPO DE DOCUMENTO' },
        { text: 'INSTITUCIÓN ACADÉMICA' },
        { text: 'ESCUELA' },
        { text: 'FOLIO DE CERTIFICADO' },
        { text: 'FECHA DE TÉRMINO DE ESTUDIOS' },
        { text: 'OFICIO DE SOLICITUD DE VALIDACIÓN' },
        { text: 'FECHA DE OFICIO DE SOLICITUD' },
        { text: 'OFICIO DE RESPUESTA DE VALIDACIÓN' },
        { text: 'FECHA DE OFICIO DE RESPUESTA' },
        { text: 'RESULTADO' },
      ],
      contenidoCartilla: [{ text: 'OFICIO DE VALIDACIÓN' }, { text: 'FECHA DE OFICIO' }, { text: 'MATRÍCULA DE CARTILLA' }, { text: 'RESULTADO' }],
    };
  },

  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    getDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped>
    .font {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
    }
    th,
    tr {
        border: 1px solid;
    }
    .logo {
        border: 1px solid;
        height: 80px;
    }
    .mt {
        margin-top: 40px;
    }
    .margin {
        padding: 8px 48px 8px 48px;
    }
</style>
